import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { AppBar, AppBarProps, IconButton, Toolbar } from "@mui/material";

export const DialogBar: React.FC<AppBarProps & { onClose: () => void }> = ({
  onClose,
  sx,
  ...props
}) => {
  return (
    <>
      <AppBar
        color="transparent"
        elevation={0}
        sx={{ pt: "env(safe-area-inset-top)", ...sx }}
        {...props}
      >
        <Toolbar sx={{ justifyContent: "flex-end" }}>
          <IconButton edge="end" onClick={onClose} color="primary">
            <CloseRoundedIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Toolbar sx={{ pt: "env(safe-area-inset-top)" }} />
    </>
  );
};
